import { render } from "./TemporaryDataFile.vue?vue&type=template&id=77c75888"
import script from "./TemporaryDataFile.vue?vue&type=script&lang=js"
export * from "./TemporaryDataFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__